<template>
  <div id="clientIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">客户</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
// 页面二级菜单
import SecondMenu from 'components/layout/SecondMenu';

export default {
  data() {
    return {
      secondaryMenuMap: [
        {
          menuName: '客户管理',
          url: '/admin/client/client-manage-index',
          keyword: 'ROLE_CUSTOMER_show',
          childrenMenu: []
        },
        {
          menuName: '标签管理',
          url: '/admin/client/tag-manage',
          keyword: 'ROLE_CUSTOMER_label',
          childrenMenu: []
        },
        {
          menuName: '客户等级',
          url: '/admin/client/client-grade',
          keyword: 'ROLE_CUSTOMER_level',
          childrenMenu: []
        },
        {
          menuName: '登录统计',
          url: '/admin/client/login-statistics-index',
          keyword: 'ROLE_CUSTOMER_statistics',
          childrenMenu: []
        }
      ]
    };
  },
  methods: {
    onMenuConfirm(url) {
      // 路由跳转
      console.log('路由--', url);
      this.$router.push({
        path: url
      });
    }
  },
  components: {
    SecondMenu
  }
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
